import { useCallback } from "react";

// Calculate total discount amount by price
const calculateDiscountAmountByPrice = (price: number, discount: number) =>
  price * (discount / 100);

// Calculate total tax amount by price
const calculateTaxAmountByPrice = (tax: number, price: number) =>
  price * (tax / 100);

// Calculate total amount by price, quantity and tax
const calculateTotalAmountByService = (
  price: number,
  quantity: number,
  tax: number
): number => {
  const totalPrice = price * quantity;
  const taxation = calculateTaxAmountByPrice(tax, totalPrice);

  return totalPrice + taxation;
};

// Calculate total amount from list
const calculateTotalAmount = (servicesArray: { totalAmount: string }[]) =>
  servicesArray.reduce(
    (acc: number, i: { totalAmount: string }) => acc + Number(i.totalAmount),
    0
  );

// Calculate total tax from list
const calculateTaxAmount = (serviceArray: { tax: string; amount: string }[]) =>
  serviceArray.reduce(
    (acc: number, { tax, amount }: { tax: string; amount: string }) =>
      acc + calculateTaxAmountByPrice(Number(tax), Number(amount)),
    0
  );

const useBillCalculation = ({
  couponList,
}: {
  couponList: { data: { rows: { id: number; discount: number }[] } };
}) => {
  const getCouponDataById = useCallback(
    (couponId: number) =>
      couponList?.data?.rows?.find(({ id }: { id: number }) => couponId === id)
        ?.discount ?? 0,
    [couponList?.data?.rows]
  );
  return {
    calculateTotalAmountByService,
    calculateTotalAmount,
    calculateTaxAmount,
    calculateDiscountAmountByPrice,
    getCouponDataById,
  };
};

export default useBillCalculation;
